module.exports = __webpack_public_path__ + "img/hr-wooden-particle-18.a07a4a47.png";